import { queriesOAuth } from "@query";

/**
 * Read the interaction the OAuth authorize redirect handed us.
 *
 * The endpoint is a POST despite the `get` prefix, and the context it returns
 * carries a single-use `decisionNonce`. Caching it would let a back-navigation
 * replay a spent nonce into the decision call, so this deliberately opts out of
 * the query cache instead of taking the layer's defaults.
 */
export const useQueryOAuthAuthorizeContext = (interactionId: string) =>
  queriesOAuth.getOAuthAuthorizeContext.useQuery(
    { oAuthInteractionReference: { interactionId } },
    {
      enabled: !!interactionId,
      staleTime: 0,
      cacheTime: 0,
      retry: false,
      refetchOnWindowFocus: false
    }
  );

/**
 * Submit the approve/deny decision.
 *
 * No `onSuccess` navigation here: the response is a three-branch union and only
 * the route can decide between navigating, confirming the destination first, or
 * rendering an error in place.
 */
export const useMutationOAuthAuthorizeDecision = () =>
  queriesOAuth.decideOAuthAuthorization.useMutation();
